import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from '../components/terms.vue'

document.addEventListener('DOMContentLoaded', () => {
  const el = '#app'
  const app = new Vue({
    el,
    render: h => h(App)
  })
})
